<template>
  <div class="ai-visibility-competitors-toolbar">
    <div class="ai-visibility-competitors-toolbar__copy">
      <h2>{{ title }}</h2>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <div class="ai-visibility-competitors-toolbar__controls">
      <ai-visibility-search-input
          :value="search"
          placeholder="Search"
          @input="$emit('update:search', $event)"
          @clear="$emit('update:search', '')"
      />
      <icon-button
          icon="file_download"
          aria-label="Export competitors"
          @click="$emit('export')"
      />
    </div>
  </div>
</template>

<script>
import AiVisibilitySearchInput from '../../../ui/controls/AiVisibilitySearchInput.vue'
import IconButton from '../../../ui/controls/IconButton.vue'

export default {
  name: 'CompetitorsToolbar',
  components: {
    AiVisibilitySearchInput,
    IconButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-competitors-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 20px;
}

.ai-visibility-competitors-toolbar__copy {
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-visibility-competitors-toolbar h2 {
  color: var(--v-mainColor-base);
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  margin: 0;
}

.ai-visibility-competitors-toolbar p {
  color: var(--v-darkGrayColor-base);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.45;
  margin: 5px 0 0;
}

.ai-visibility-competitors-toolbar__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  ::v-deep .ai-visibility-icon-button i {
    color: var(--v-mainColor-base);
  }
}

@media (max-width: 860px) {
  .ai-visibility-competitors-toolbar {
    flex-direction: column;
  }

  .ai-visibility-competitors-toolbar__controls {
    justify-content: flex-start;
    width: 100%;
  }
}
</style>
